"use client"

import MagGlass from "images/Icons/MagGlassL.inline.svg"
import XL from "images/Icons/XL.inline.svg"
import UniversalLink from "library/link"
import { css, fmobile, fresponsive, styled } from "library/styled"
import colors from "styles/colors"
import textStyles from "styles/text"

interface SearchBarProps {
	value: string
	action: (value: string) => void
}

export function SearchBar({ value, action }: SearchBarProps) {
	return (
		<Wrapper>
			<Label>
				<Input
					placeholder="Search Articles"
					value={value}
					onChange={(e) => action(e.target.value)}
				/>
			</Label>
			<RightIndicator cursorOn={!!value}>
				{value ? (
					<UniversalLink type="button" onClick={() => action("")}>
						<Icon>
							<XL />
						</Icon>
					</UniversalLink>
				) : (
					<Icon>
						<MagGlass />
					</Icon>
				)}
			</RightIndicator>
		</Wrapper>
	)
}

const Wrapper = styled("div", {
	...fresponsive(css`
		display: grid;
		position: relative;
		grid-template-columns: auto 1fr auto;
		gap: 10px;
		${textStyles.h3};
		margin: 80px auto 0;
		width: 100%;
	`),
	...fmobile(css`
		${textStyles.bodyXL};
		width: 327px;
		margin: 40px 0 0;
	`),
})

const Label = styled(
	"label",
	fresponsive(css`
		display: grid;
	`),
)

const Input = styled("input", {
	...fresponsive(css`
		border-bottom: 1px solid ${colors.green500};
		padding: 10px 10px 48px;
		outline: none;
	`),
	...fmobile(css`
		padding: 0 0 24px;
	`),
})

const Icon = styled(
	"div",
	fresponsive(css`
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		color: ${colors.green500};
	`),
)

const RightIndicator = styled("div", ({ cursorOn }: { cursorOn: boolean }) => {
	return {
		...fresponsive(css`
			display: flex;
			align-items: center;
			justify-content: center;
			width: 50px;
			height: 50px;
			cursor: ${cursorOn ? "pointer" : "default"};
			position: absolute;
			right: 5px;
			bottom: 50px;

			svg {
				width: 100%;
				height: 100%;
				color: ${colors.green500};
			}
		`),
		...fmobile(css`
			width: 32px;
			height: 32px;
			top: 4px;
			right: 10px;
		`),
	}
})
